<template>

  <el-tabs v-model="activeName" style="margin-top: 20px" type="card" @tab-click="handleClick">

    <el-tab-pane label="资讯列表" name="information">
      <InfoComponent type="1"></InfoComponent>
    </el-tab-pane>
    <el-tab-pane label="专栏博客" name="blob">
      <InfoComponent type="3"></InfoComponent>
    </el-tab-pane>

    <el-tab-pane label="社区活动" name="activity">
      <InfoComponent type="4"></InfoComponent>
    </el-tab-pane>
    <el-tab-pane label="问答" name="question">
      <InfoComponent type="2"></InfoComponent>
    </el-tab-pane>
  </el-tabs>


</template>

<script>
  import InfoComponent from '@/components/System/community/InfoComponent'

  export default {
    components: {InfoComponent},
    data() {
      return {
        activeName: "information"
      }
    },
    created() {
    },
    mounted: function () {
      let type = this.$route.query.type;
      switch (type) {
        case '1':
          this.activeName = "information";
          break;
        case '2':
          this.activeName = "question";
          break;
        case '3':
          this.activeName = "blob";
          break;
        case '4':
          this.activeName = "activity";
          break;
      }
    },
    methods: {
      handleClick: function () {

      }
    }
  }
</script>

